import api from './axios';

export const ordersApi = {
  getAll: (filters?: any) => api.get('/orders', { params: filters }),
  getActive: () => api.get('/orders/active'),
  getKitchen: () => api.get('/orders/kitchen'),
  getBar: () => api.get('/orders/bar'),
  getTodaySummary: () => api.get('/orders/summary/today'),
  getById: (id: number) => api.get(`/orders/${id}`),
  // Modalidad del flujo: 'tradicional' (cocina/bar) o 'mozo' (comanda al mozo).
  getFlowConfig: () =>
    api.get<{
      mode: 'tradicional' | 'mozo';
      comandaToWaiter: boolean;
      skipKitchenStates: boolean;
      requiresCustomerName: boolean;
    }>('/orders/flow-config'),
  // El mozo confirma que entrego el pedido al cliente (no cobra ni cierra la cuenta).
  markServed: (orderId: number) => api.patch(`/orders/${orderId}/status`, { status: 'servido' }),
  create: (data: any) => api.post('/orders', data),
  addItems: (orderId: number, items: any[]) => api.post(`/orders/${orderId}/items`, { items }),
  updateStatus: (orderId: number, status: string) =>
    api.patch(`/orders/${orderId}/status`, { status }),
  // Cobrar: marca pagado (emite comprobante). Acepta datos opcionales del cliente
  // y un array de payments para pagos mixtos (ej. Visa S/30 + Yape S/14).
  pagar: (
    orderId: number,
    data?: {
      customerName?: string;
      customerDocType?: string;
      customerDocument?: string;
      paymentMethod?: string;
      payments?: Array<{
        method: string;
        amount: number;
        reference?: string;
        currency?: 'PEN' | 'USD';
        customerId?: number;
        dueDate?: string;
      }>;
      comprobanteType?: 'boleta' | 'factura' | 'nota_venta' | 'doc_interno';
      porConsumo?: boolean;
    },
  ) => api.patch(`/orders/${orderId}/status`, { status: 'pagado', ...(data || {}) }),
  updateItemStatus: (itemId: number, status: string) =>
    api.patch(`/orders/items/${itemId}/status`, { status }),
  // Vista previa de la comanda por estacion (no imprime ni cambia estados).
  previewComanda: (orderId: number) => api.get(`/orders/${orderId}/comanda/preview`),
  // Imprime la comanda en las ticketeras configuradas, sin crear tickets nuevos.
  printComanda: (orderId: number) => api.post(`/orders/${orderId}/comanda/print`),
  delete: (orderId: number) => api.delete(`/orders/${orderId}`),
  // Dividir cuenta por items: mueve los items indicados a un nuevo pedido.
  split: (orderId: number, itemIds: number[], newTableId?: number) =>
    api.post(`/orders/${orderId}/split`, { itemIds, newTableId }),
  // RF-04b: dividir cuenta en N partes iguales (N=2..10). Crea N hijos sin items.
  splitEqual: (orderId: number, parts: number) =>
    api.post(`/orders/${orderId}/split-equal`, { parts }),
  // RF-03: traspasar un item a otra mesa con autorizacion admin.
  transferItem: (
    sourceOrderId: number,
    payload: {
      itemId: number;
      targetTableId?: number;
      targetOrderId?: number;
      adminEmail?: string;
      adminPassword?: string;
      reason?: string;
    },
  ) => api.post(`/orders/${sourceOrderId}/transfer-item`, payload),
};
